import ReviewLabel from "./ReviewLabel";
export default ReviewLabel;
